import { Countdown } from 'components/Countdown';
import { StardustRushContext } from 'contexts/stardustRush/stardustRush';
import { getTimeLeft } from 'helpers/timer';
import type { FC } from 'react';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const StardustRushTimer: FC = () => {
  const { t } = useTranslation();

  const { stardustRushCMSData } = useContext(StardustRushContext);

  const timeLeft = useMemo(
    () => Math.max(getTimeLeft(stardustRushCMSData?.endDate || ''), 0),
    [stardustRushCMSData?.endDate]
  );

  return (
    <Countdown dual timeLeft={timeLeft}>
      {({ days, hours, minutes }) => (
        <>
          <span>
            {days}
            {t('timerShort.d')}
          </span>
          :
          <span>
            {hours}
            {t('timerShort.h')}
          </span>
          :
          <span>
            {minutes}
            {t('timerShort.m')}
          </span>
        </>
      )}
    </Countdown>
  );
};
